var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 22.5771H53.2686V26.9427H57.6341V22.5771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 26.9453H53.2686V31.3109H57.6341V26.9453Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 31.3113H53.2686V35.6769H57.6341V31.3113Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 35.6765H53.2686V40.0421H57.6341V35.6765Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 40.0444H53.2686V44.4898H57.6341V40.0444Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 44.4905H53.2686V48.8561H57.6341V44.4905Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 48.8557H53.2686V53.2213H57.6341V48.8557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 53.2212H53.2686V57.5867H57.6341V53.2212Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 57.5898H53.2686V61.9554H57.6341V57.5898Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 61.9551H53.2686V66.4004H57.6341V61.9551Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 66.4004H53.2686V70.7659H57.6341V66.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 70.7656H53.2686V75.1312H57.6341V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 26.9453H57.6338V31.3109H61.9993V26.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 31.3113H57.6338V35.6769H61.9993V31.3113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 35.6765H57.6338V40.0421H61.9993V35.6765Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 40.0444H57.6338V44.4898H61.9993V40.0444Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 44.4905H57.6338V48.8561H61.9993V44.4905Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 48.8557H57.6338V53.2213H61.9993V48.8557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 53.2212H57.6338V57.5867H61.9993V53.2212Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 57.5898H57.6338V61.9554H61.9993V57.5898Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 61.9551H57.6338V66.4004H61.9993V61.9551Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 66.4004H57.6338V70.7659H61.9993V66.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 70.7656H57.6338V75.1312H61.9993V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 35.6765H62.0015V40.0421H66.367V35.6765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 40.0444H62.0015V44.4898H66.367V40.0444Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 44.4905H62.0015V48.8561H66.367V44.4905Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 48.8557H62.0015V53.2213H66.367V48.8557Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 53.2212H62.0015V57.5867H66.367V53.2212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 57.5898H62.0015V61.9554H66.367V57.5898Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 61.9551H62.0015V66.4004H66.367V61.9551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 66.4004H62.0015V70.7659H66.367V66.4004Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 70.7656H62.0015V75.1312H66.367V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7323 44.4905H66.3667V48.8561H70.7323V44.4905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7323 48.8557H66.3667V53.2213H70.7323V48.8557Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7323 53.2212H66.3667V57.5867H70.7323V53.2212Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7323 57.5898H66.3667V61.9554H70.7323V57.5898Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7323 61.9551H66.3667V66.4004H70.7323V61.9551Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7323 66.4004H66.3667V70.7659H70.7323V66.4004Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7323 70.7656H66.3667V75.1312H70.7323V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1802 48.8557H70.7349V53.2213H75.1802V48.8557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1802 53.2212H70.7349V57.5867H75.1802V53.2212Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1802 57.5898H70.7349V61.9554H75.1802V57.5898Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1802 61.9551H70.7349V66.4004H75.1802V61.9551Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1802 66.4004H70.7349V70.7659H75.1802V66.4004Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1802 70.7656H70.7349V75.1312H75.1802V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5438 57.5898H75.1782V61.9554H79.5438V57.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5438 61.9551H75.1782V66.4004H79.5438V61.9551Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5438 66.4004H75.1782V70.7659H79.5438V66.4004Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5438 70.7656H75.1782V75.1312H79.5438V70.7656Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9119 66.4004H79.5464V70.7659H83.9119V66.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9119 70.7656H79.5464V75.1312H83.9119V70.7656Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2772 70.7656H83.9116V75.1312H88.2772V70.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 26.9453H48.8223V31.3109H53.2676V26.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 31.3113H48.8223V35.6769H53.2676V31.3113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 35.6765H48.8223V40.0421H53.2676V35.6765Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 40.0444H48.8223V44.4898H53.2676V40.0444Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 44.4905H48.8223V48.8561H53.2676V44.4905Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 48.8557H48.8223V53.2213H53.2676V48.8557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 53.2212H48.8223V57.5867H53.2676V53.2212Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 57.5898H48.8223V61.9554H53.2676V57.5898Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 61.9551H48.8223V66.4004H53.2676V61.9551Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 66.4004H48.8223V70.7659H53.2676V66.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 70.7656H48.8223V75.1312H53.2676V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 35.6765H44.457V40.0421H48.8226V35.6765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 40.0444H44.457V44.4898H48.8226V40.0444Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 44.4905H44.457V48.8561H48.8226V44.4905Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 48.8557H44.457V53.2213H48.8226V48.8557Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 53.2212H44.457V57.5867H48.8226V53.2212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 57.5898H44.457V61.9554H48.8226V57.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 61.9551H44.457V66.4004H48.8226V61.9551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 66.4004H44.457V70.7659H48.8226V66.4004Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 70.7656H44.457V75.1312H48.8226V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 44.4905H40.0889V48.8561H44.4544V44.4905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 48.8557H40.0889V53.2213H44.4544V48.8557Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 53.2212H40.0889V57.5867H44.4544V53.2212Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 57.5898H40.0889V61.9554H44.4544V57.5898Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 61.9551H40.0889V66.4004H44.4544V61.9551Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 66.4004H40.0889V70.7659H44.4544V66.4004Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 70.7656H40.0889V75.1312H44.4544V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0892 48.8557H35.7236V53.2213H40.0892V48.8557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0892 53.2212H35.7236V57.5867H40.0892V53.2212Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0892 57.5898H35.7236V61.9554H40.0892V57.5898Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0892 61.9551H35.7236V66.4004H40.0892V61.9551Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0892 66.4004H35.7236V70.7659H40.0892V66.4004Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0892 70.7656H35.7236V75.1312H40.0892V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7232 57.5898H31.2778V61.9554H35.7232V57.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7232 61.9551H31.2778V66.4004H35.7232V61.9551Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7232 66.4004H31.2778V70.7659H35.7232V66.4004Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7232 70.7656H31.2778V75.1312H35.7232V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2782 66.4004H26.9126V70.7659H31.2782V66.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2782 70.7656H26.9126V75.1312H31.2782V70.7656Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9124 70.7656H22.5469V75.1312H26.9124V70.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7323 40.0444H66.3667V44.4898H70.7323V40.0444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 40.0444H40.0889V44.4898H44.4544V40.0444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 75.1345H53.2686V79.5001H57.6341V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9993 75.1345H57.6338V79.5001H61.9993V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.367 75.1345H62.0015V79.5001H66.367V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7323 75.1345H66.3667V79.5001H70.7323V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1802 75.1345H70.7349V79.5001H75.1802V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5438 75.1345H75.1782V79.5001H79.5438V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9119 75.1345H79.5464V79.5001H83.9119V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2772 75.1345H83.9116V79.5001H88.2772V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 75.1345H48.8223V79.5001H53.2676V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 75.1345H44.457V79.5001H48.8226V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 75.1345H40.0889V79.5001H44.4544V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0892 75.1345H35.7236V79.5001H40.0892V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7232 75.1345H31.2778V79.5001H35.7232V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2782 75.1345H26.9126V79.5001H31.2782V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9124 75.1345H22.5469V79.5001H26.9124V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7251 75.1345H88.2798V79.5001H92.7251V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5423 75.1345H18.1768V79.5001H22.5423V75.1345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2782 61.9551H26.9126V66.4004H31.2782V61.9551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9119 61.9551H79.5464V66.4004H83.9119V61.9551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7232 53.2212H31.2778V57.5867H35.7232V53.2212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5438 53.2212H75.1782V57.5867H79.5438V53.2212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 26.9453H53.2686V31.3109H57.6341V26.9453Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2676 22.5771H48.8223V26.9427H53.2676V22.5771Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 26.9453H44.457V31.3109H48.8226V26.9453Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8226 31.3113H44.457V35.6769H48.8226V31.3113Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4544 35.6765H40.0889V40.0421H44.4544V35.6765Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0892 44.4905H35.7236V48.8561H40.0892V44.4905Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7232 48.8557H31.2778V53.2213H35.7232V48.8557Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2782 57.5898H26.9126V61.9554H31.2782V57.5898Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9124 66.4004H22.5469V70.7659H26.9124V66.4004Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5423 70.7656H18.1768V75.1312H22.5423V70.7656Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0892 40.0444H35.7236V44.4898H40.0892V40.0444Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1766 75.1345H13.811V79.5001H18.1766V75.1345Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9124 61.9551H22.5469V66.4004H26.9124V61.9551Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2782 53.2212H26.9126V57.5867H31.2782V53.2212Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9119 40.0444H79.5464V44.4898H83.9119V40.0444Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2772 35.6765H83.9116V40.0421H88.2772V35.6765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7251 31.3113H88.2798V35.6769H92.7251V31.3113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9124 44.4905H22.5469V48.8561H26.9124V44.4905Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5423 40.0444H18.1768V44.4898H22.5423V40.0444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1766 35.6765H13.811V40.0421H18.1766V35.6765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8135 31.3113H9.36816V35.6769H13.8135V31.3113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1766 57.5898H13.811V61.9554H18.1766V57.5898Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8135 57.5898H9.36816V61.9554H13.8135V57.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36556 57.5898H5V61.9554H9.36556V57.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4613 57.5898H86.0957V61.9554H90.4613V57.5898Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9063 57.5898H90.4609V61.9554H94.9063V57.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 22.5H53.2686V26.9453H57.6341V22.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.65b6384c256c634afe8ed2ad4f142383.svg";
export { ForwardRef as ReactComponent };